/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SolidOps API
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod';

export const ownDutyResponseOutputSourcesItemScheduleIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const ownDutyResponseOutputSourcesItemRoutineIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const ownDutyResponseOutputSourcesMax = 3000;

export const ownDutyResponseOutputTimelineDaySlicesItemStartRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
);
export const ownDutyResponseOutputTimelineDaySlicesItemEndRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
);
export const ownDutyResponseOutputTimelineDaySlicesMax = 35;

export const ownDutyResponseOutputTimelineAgentsItemIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const ownDutyResponseOutputTimelineAgentsItemDisplayNameMax = 500;

export const ownDutyResponseOutputTimelineAgentsItemInitialsMax = 8;

export const ownDutyResponseOutputTimelineAgentsMax = 1000;

export const ownDutyResponseOutputTimelineRangeStartRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
);
export const ownDutyResponseOutputTimelineRangeEndRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
);
export const ownDutyResponseOutputTimelineDisplayTimeZoneMax = 100;

export const ownDutyResponseOutputTimelineSchedulesItemScheduleIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const ownDutyResponseOutputTimelineSchedulesItemTimeZoneMax = 100;

export const ownDutyResponseOutputTimelineSchedulesItemVersionExclusiveMin = 0;
export const ownDutyResponseOutputTimelineSchedulesItemVersionMax = 9007199254740991;

export const ownDutyResponseOutputTimelineSchedulesItemRoutinesItemPendingHistoryOneStartRegExp =
  new RegExp(
    '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
  );
export const ownDutyResponseOutputTimelineSchedulesItemRoutinesItemPendingHistoryOneEndRegExp =
  new RegExp(
    '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
  );
export const ownDutyResponseOutputTimelineSchedulesItemRoutinesItemRoutineIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const ownDutyResponseOutputTimelineSchedulesItemRoutinesItemRotationCountExclusiveMin = 0;
export const ownDutyResponseOutputTimelineSchedulesItemRoutinesItemRotationCountMax = 2147483647;

export const ownDutyResponseOutputTimelineSchedulesItemRoutinesItemOriginalItemStartRegExp =
  new RegExp(
    '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
  );
export const ownDutyResponseOutputTimelineSchedulesItemRoutinesItemOriginalItemEndRegExp =
  new RegExp(
    '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
  );
export const ownDutyResponseOutputTimelineSchedulesItemRoutinesItemOriginalItemSourceScheduleIdRegExp =
  new RegExp(
    '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
  );
export const ownDutyResponseOutputTimelineSchedulesItemRoutinesItemOriginalItemSourceRoutineIdRegExp =
  new RegExp(
    '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
  );
export const ownDutyResponseOutputTimelineSchedulesItemRoutinesItemOriginalItemSourceRoutineVersionIdRegExp =
  new RegExp(
    '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
  );
export const ownDutyResponseOutputTimelineSchedulesItemRoutinesItemOriginalItemSourcePositionIdRegExp =
  new RegExp(
    '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
  );
export const ownDutyResponseOutputTimelineSchedulesItemRoutinesItemOriginalItemSourceOriginalUserIdRegExp =
  new RegExp(
    '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
  );
export const ownDutyResponseOutputTimelineSchedulesItemRoutinesItemOriginalItemSourceOverrideIdOneRegExp =
  new RegExp(
    '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
  );
export const ownDutyResponseOutputTimelineSchedulesItemRoutinesItemOriginalItemUserIdOneRegExp =
  new RegExp(
    '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
  );
export const ownDutyResponseOutputTimelineSchedulesItemRoutinesItemOriginalItemStartOffsetRegExp =
  new RegExp('^[+-](?:[01]\\d|2[0-3]):[0-5]\\d$');
export const ownDutyResponseOutputTimelineSchedulesItemRoutinesItemOriginalItemEndOffsetRegExp =
  new RegExp('^[+-](?:[01]\\d|2[0-3]):[0-5]\\d$');
export const ownDutyResponseOutputTimelineSchedulesItemRoutinesItemOriginalItemHistoryRecordedThroughOneRegExp =
  new RegExp(
    '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
  );
export const ownDutyResponseOutputTimelineSchedulesItemRoutinesItemOriginalMax = 10000;

export const ownDutyResponseOutputTimelineSchedulesItemRoutinesItemOverridesItemOverrideIdRegExp =
  new RegExp(
    '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
  );
export const ownDutyResponseOutputTimelineSchedulesItemRoutinesItemOverridesItemSubstituteUserIdRegExp =
  new RegExp(
    '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
  );
export const ownDutyResponseOutputTimelineSchedulesItemRoutinesItemOverridesItemStartRegExp =
  new RegExp(
    '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
  );
export const ownDutyResponseOutputTimelineSchedulesItemRoutinesItemOverridesItemEndRegExp =
  new RegExp(
    '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
  );
export const ownDutyResponseOutputTimelineSchedulesItemRoutinesItemOverridesMax = 10000;

export const ownDutyResponseOutputTimelineSchedulesItemRoutinesItemFinalItemStartRegExp =
  new RegExp(
    '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
  );
export const ownDutyResponseOutputTimelineSchedulesItemRoutinesItemFinalItemEndRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
);
export const ownDutyResponseOutputTimelineSchedulesItemRoutinesItemFinalItemSourceScheduleIdRegExp =
  new RegExp(
    '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
  );
export const ownDutyResponseOutputTimelineSchedulesItemRoutinesItemFinalItemSourceRoutineIdRegExp =
  new RegExp(
    '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
  );
export const ownDutyResponseOutputTimelineSchedulesItemRoutinesItemFinalItemSourceRoutineVersionIdRegExp =
  new RegExp(
    '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
  );
export const ownDutyResponseOutputTimelineSchedulesItemRoutinesItemFinalItemSourcePositionIdRegExp =
  new RegExp(
    '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
  );
export const ownDutyResponseOutputTimelineSchedulesItemRoutinesItemFinalItemSourceOriginalUserIdRegExp =
  new RegExp(
    '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
  );
export const ownDutyResponseOutputTimelineSchedulesItemRoutinesItemFinalItemSourceOverrideIdOneRegExp =
  new RegExp(
    '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
  );
export const ownDutyResponseOutputTimelineSchedulesItemRoutinesItemFinalItemUserIdOneRegExp =
  new RegExp(
    '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
  );
export const ownDutyResponseOutputTimelineSchedulesItemRoutinesItemFinalItemStartOffsetRegExp =
  new RegExp('^[+-](?:[01]\\d|2[0-3]):[0-5]\\d$');
export const ownDutyResponseOutputTimelineSchedulesItemRoutinesItemFinalItemEndOffsetRegExp =
  new RegExp('^[+-](?:[01]\\d|2[0-3]):[0-5]\\d$');
export const ownDutyResponseOutputTimelineSchedulesItemRoutinesItemFinalItemHistoryRecordedThroughOneRegExp =
  new RegExp(
    '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
  );
export const ownDutyResponseOutputTimelineSchedulesItemRoutinesItemFinalMax = 10000;

export const ownDutyResponseOutputTimelineSchedulesItemRoutinesItemGapsItemStartRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
);
export const ownDutyResponseOutputTimelineSchedulesItemRoutinesItemGapsItemEndRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
);
export const ownDutyResponseOutputTimelineSchedulesItemRoutinesItemGapsMax = 10000;

export const ownDutyResponseOutputTimelineSchedulesItemRoutinesMax = 10;

export const ownDutyResponseOutputTimelineSchedulesMax = 300;

export const ownDutyResponseOutputTimelineViewVersionMax = 256;

export const ownDutyResponseOutputAgentsItemIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const ownDutyResponseOutputAgentsItemDisplayNameMax = 500;

export const ownDutyResponseOutputAgentsItemInitialsMax = 8;

export const ownDutyResponseOutputAgentsMax = 1000;

export const ownDutyResponseOutputRangeStartRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
);
export const ownDutyResponseOutputRangeEndRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
);
export const ownDutyResponseOutputCurrentItemUserIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const ownDutyResponseOutputCurrentItemSourceScheduleIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const ownDutyResponseOutputCurrentItemSourceRoutineIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const ownDutyResponseOutputCurrentItemSourceRoutineVersionIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const ownDutyResponseOutputCurrentItemSourcePositionIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const ownDutyResponseOutputCurrentItemSourceOriginalUserIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const ownDutyResponseOutputCurrentItemSourceOverrideIdOneRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const ownDutyResponseOutputCurrentItemStartRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
);
export const ownDutyResponseOutputCurrentItemEndRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
);
export const ownDutyResponseOutputCurrentMax = 3000;

export const ownDutyResponseOutputUpcomingItemUserIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const ownDutyResponseOutputUpcomingItemSourceScheduleIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const ownDutyResponseOutputUpcomingItemSourceRoutineIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const ownDutyResponseOutputUpcomingItemSourceRoutineVersionIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const ownDutyResponseOutputUpcomingItemSourcePositionIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const ownDutyResponseOutputUpcomingItemSourceOriginalUserIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const ownDutyResponseOutputUpcomingItemSourceOverrideIdOneRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const ownDutyResponseOutputUpcomingItemStartRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
);
export const ownDutyResponseOutputUpcomingItemEndRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
);
export const ownDutyResponseOutputUpcomingMax = 10000;

export const OwnDutyResponseOutput = zod.object({
  sources: zod
    .array(
      zod.object({
        scheduleId: zod.uuid().regex(ownDutyResponseOutputSourcesItemScheduleIdRegExp),
        scheduleName: zod.unknown().and(zod.unknown()),
        routineId: zod.uuid().regex(ownDutyResponseOutputSourcesItemRoutineIdRegExp),
        routineName: zod.unknown().and(zod.unknown()),
      }),
    )
    .max(ownDutyResponseOutputSourcesMax)
    .optional(),
  timeline: zod
    .object({
      daySlices: zod
        .array(
          zod.object({
            start: zod.iso
              .datetime({ offset: true })
              .regex(ownDutyResponseOutputTimelineDaySlicesItemStartRegExp),
            end: zod.iso
              .datetime({ offset: true })
              .regex(ownDutyResponseOutputTimelineDaySlicesItemEndRegExp),
          }),
        )
        .max(ownDutyResponseOutputTimelineDaySlicesMax)
        .optional(),
      agents: zod
        .array(
          zod.object({
            id: zod.uuid().regex(ownDutyResponseOutputTimelineAgentsItemIdRegExp),
            displayName: zod
              .string()
              .min(1)
              .max(ownDutyResponseOutputTimelineAgentsItemDisplayNameMax),
            initials: zod.string().min(1).max(ownDutyResponseOutputTimelineAgentsItemInitialsMax),
          }),
        )
        .max(ownDutyResponseOutputTimelineAgentsMax)
        .optional(),
      range: zod.object({
        start: zod.iso
          .datetime({ offset: true })
          .regex(ownDutyResponseOutputTimelineRangeStartRegExp),
        end: zod.iso.datetime({ offset: true }).regex(ownDutyResponseOutputTimelineRangeEndRegExp),
      }),
      displayTimeZone: zod.string().min(1).max(ownDutyResponseOutputTimelineDisplayTimeZoneMax),
      schedules: zod
        .array(
          zod.object({
            scheduleId: zod
              .uuid()
              .regex(ownDutyResponseOutputTimelineSchedulesItemScheduleIdRegExp),
            name: zod.unknown().and(zod.unknown()),
            timeZone: zod
              .string()
              .min(1)
              .max(ownDutyResponseOutputTimelineSchedulesItemTimeZoneMax),
            version: zod
              .int()
              .gt(ownDutyResponseOutputTimelineSchedulesItemVersionExclusiveMin)
              .max(ownDutyResponseOutputTimelineSchedulesItemVersionMax),
            routines: zod
              .array(
                zod.object({
                  pendingHistory: zod
                    .union([
                      zod.object({
                        start: zod.iso
                          .datetime({ offset: true })
                          .regex(
                            ownDutyResponseOutputTimelineSchedulesItemRoutinesItemPendingHistoryOneStartRegExp,
                          ),
                        end: zod.iso
                          .datetime({ offset: true })
                          .regex(
                            ownDutyResponseOutputTimelineSchedulesItemRoutinesItemPendingHistoryOneEndRegExp,
                          ),
                      }),
                      zod.null(),
                    ])
                    .optional(),
                  routineId: zod
                    .uuid()
                    .regex(ownDutyResponseOutputTimelineSchedulesItemRoutinesItemRoutineIdRegExp),
                  name: zod.unknown().and(zod.unknown()),
                  rotation: zod.object({
                    unit: zod.enum(['day', 'week']),
                    count: zod
                      .int()
                      .gt(
                        ownDutyResponseOutputTimelineSchedulesItemRoutinesItemRotationCountExclusiveMin,
                      )
                      .max(ownDutyResponseOutputTimelineSchedulesItemRoutinesItemRotationCountMax),
                  }),
                  original: zod
                    .array(
                      zod.object({
                        start: zod.iso
                          .datetime({ offset: true })
                          .regex(
                            ownDutyResponseOutputTimelineSchedulesItemRoutinesItemOriginalItemStartRegExp,
                          ),
                        end: zod.iso
                          .datetime({ offset: true })
                          .regex(
                            ownDutyResponseOutputTimelineSchedulesItemRoutinesItemOriginalItemEndRegExp,
                          ),
                        source: zod.object({
                          scheduleId: zod
                            .uuid()
                            .regex(
                              ownDutyResponseOutputTimelineSchedulesItemRoutinesItemOriginalItemSourceScheduleIdRegExp,
                            ),
                          routineId: zod
                            .uuid()
                            .regex(
                              ownDutyResponseOutputTimelineSchedulesItemRoutinesItemOriginalItemSourceRoutineIdRegExp,
                            ),
                          routineVersionId: zod
                            .uuid()
                            .regex(
                              ownDutyResponseOutputTimelineSchedulesItemRoutinesItemOriginalItemSourceRoutineVersionIdRegExp,
                            ),
                          positionId: zod
                            .uuid()
                            .regex(
                              ownDutyResponseOutputTimelineSchedulesItemRoutinesItemOriginalItemSourcePositionIdRegExp,
                            ),
                          originalUserId: zod
                            .uuid()
                            .regex(
                              ownDutyResponseOutputTimelineSchedulesItemRoutinesItemOriginalItemSourceOriginalUserIdRegExp,
                            ),
                          originalEligible: zod.boolean(),
                          overrideId: zod.union([
                            zod
                              .uuid()
                              .regex(
                                ownDutyResponseOutputTimelineSchedulesItemRoutinesItemOriginalItemSourceOverrideIdOneRegExp,
                              ),
                            zod.null(),
                          ]),
                        }),
                        userId: zod.union([
                          zod
                            .uuid()
                            .regex(
                              ownDutyResponseOutputTimelineSchedulesItemRoutinesItemOriginalItemUserIdOneRegExp,
                            ),
                          zod.null(),
                        ]),
                        eligible: zod.boolean(),
                        startOffset: zod
                          .string()
                          .regex(
                            ownDutyResponseOutputTimelineSchedulesItemRoutinesItemOriginalItemStartOffsetRegExp,
                          ),
                        endOffset: zod
                          .string()
                          .regex(
                            ownDutyResponseOutputTimelineSchedulesItemRoutinesItemOriginalItemEndOffsetRegExp,
                          ),
                        history: zod.object({
                          recordedThrough: zod.union([
                            zod.iso
                              .datetime({ offset: true })
                              .regex(
                                ownDutyResponseOutputTimelineSchedulesItemRoutinesItemOriginalItemHistoryRecordedThroughOneRegExp,
                              ),
                            zod.null(),
                          ]),
                          finalized: zod.boolean(),
                        }),
                      }),
                    )
                    .max(ownDutyResponseOutputTimelineSchedulesItemRoutinesItemOriginalMax),
                  overrides: zod
                    .array(
                      zod.object({
                        overrideId: zod
                          .uuid()
                          .regex(
                            ownDutyResponseOutputTimelineSchedulesItemRoutinesItemOverridesItemOverrideIdRegExp,
                          ),
                        substituteUserId: zod
                          .uuid()
                          .regex(
                            ownDutyResponseOutputTimelineSchedulesItemRoutinesItemOverridesItemSubstituteUserIdRegExp,
                          ),
                        start: zod.iso
                          .datetime({ offset: true })
                          .regex(
                            ownDutyResponseOutputTimelineSchedulesItemRoutinesItemOverridesItemStartRegExp,
                          ),
                        end: zod.iso
                          .datetime({ offset: true })
                          .regex(
                            ownDutyResponseOutputTimelineSchedulesItemRoutinesItemOverridesItemEndRegExp,
                          ),
                        effective: zod.boolean(),
                        eligible: zod.boolean(),
                      }),
                    )
                    .max(ownDutyResponseOutputTimelineSchedulesItemRoutinesItemOverridesMax),
                  final: zod
                    .array(
                      zod.object({
                        start: zod.iso
                          .datetime({ offset: true })
                          .regex(
                            ownDutyResponseOutputTimelineSchedulesItemRoutinesItemFinalItemStartRegExp,
                          ),
                        end: zod.iso
                          .datetime({ offset: true })
                          .regex(
                            ownDutyResponseOutputTimelineSchedulesItemRoutinesItemFinalItemEndRegExp,
                          ),
                        source: zod.object({
                          scheduleId: zod
                            .uuid()
                            .regex(
                              ownDutyResponseOutputTimelineSchedulesItemRoutinesItemFinalItemSourceScheduleIdRegExp,
                            ),
                          routineId: zod
                            .uuid()
                            .regex(
                              ownDutyResponseOutputTimelineSchedulesItemRoutinesItemFinalItemSourceRoutineIdRegExp,
                            ),
                          routineVersionId: zod
                            .uuid()
                            .regex(
                              ownDutyResponseOutputTimelineSchedulesItemRoutinesItemFinalItemSourceRoutineVersionIdRegExp,
                            ),
                          positionId: zod
                            .uuid()
                            .regex(
                              ownDutyResponseOutputTimelineSchedulesItemRoutinesItemFinalItemSourcePositionIdRegExp,
                            ),
                          originalUserId: zod
                            .uuid()
                            .regex(
                              ownDutyResponseOutputTimelineSchedulesItemRoutinesItemFinalItemSourceOriginalUserIdRegExp,
                            ),
                          originalEligible: zod.boolean(),
                          overrideId: zod.union([
                            zod
                              .uuid()
                              .regex(
                                ownDutyResponseOutputTimelineSchedulesItemRoutinesItemFinalItemSourceOverrideIdOneRegExp,
                              ),
                            zod.null(),
                          ]),
                        }),
                        userId: zod.union([
                          zod
                            .uuid()
                            .regex(
                              ownDutyResponseOutputTimelineSchedulesItemRoutinesItemFinalItemUserIdOneRegExp,
                            ),
                          zod.null(),
                        ]),
                        eligible: zod.boolean(),
                        startOffset: zod
                          .string()
                          .regex(
                            ownDutyResponseOutputTimelineSchedulesItemRoutinesItemFinalItemStartOffsetRegExp,
                          ),
                        endOffset: zod
                          .string()
                          .regex(
                            ownDutyResponseOutputTimelineSchedulesItemRoutinesItemFinalItemEndOffsetRegExp,
                          ),
                        history: zod.object({
                          recordedThrough: zod.union([
                            zod.iso
                              .datetime({ offset: true })
                              .regex(
                                ownDutyResponseOutputTimelineSchedulesItemRoutinesItemFinalItemHistoryRecordedThroughOneRegExp,
                              ),
                            zod.null(),
                          ]),
                          finalized: zod.boolean(),
                        }),
                      }),
                    )
                    .max(ownDutyResponseOutputTimelineSchedulesItemRoutinesItemFinalMax),
                  gaps: zod
                    .array(
                      zod.object({
                        start: zod.iso
                          .datetime({ offset: true })
                          .regex(
                            ownDutyResponseOutputTimelineSchedulesItemRoutinesItemGapsItemStartRegExp,
                          ),
                        end: zod.iso
                          .datetime({ offset: true })
                          .regex(
                            ownDutyResponseOutputTimelineSchedulesItemRoutinesItemGapsItemEndRegExp,
                          ),
                        reason: zod.enum([
                          'outside-sections',
                          'before-start',
                          'ineligible',
                          'ended',
                          'archived',
                          'empty-dst-section',
                        ]),
                      }),
                    )
                    .max(ownDutyResponseOutputTimelineSchedulesItemRoutinesItemGapsMax),
                }),
              )
              .max(ownDutyResponseOutputTimelineSchedulesItemRoutinesMax),
          }),
        )
        .max(ownDutyResponseOutputTimelineSchedulesMax),
      viewVersion: zod.string().min(1).max(ownDutyResponseOutputTimelineViewVersionMax),
    })
    .optional(),
  agents: zod
    .array(
      zod.object({
        id: zod.uuid().regex(ownDutyResponseOutputAgentsItemIdRegExp),
        displayName: zod.string().min(1).max(ownDutyResponseOutputAgentsItemDisplayNameMax),
        initials: zod.string().min(1).max(ownDutyResponseOutputAgentsItemInitialsMax),
      }),
    )
    .max(ownDutyResponseOutputAgentsMax)
    .optional(),
  range: zod.object({
    start: zod.iso.datetime({ offset: true }).regex(ownDutyResponseOutputRangeStartRegExp),
    end: zod.iso.datetime({ offset: true }).regex(ownDutyResponseOutputRangeEndRegExp),
  }),
  current: zod
    .array(
      zod.object({
        userId: zod.uuid().regex(ownDutyResponseOutputCurrentItemUserIdRegExp),
        source: zod.object({
          scheduleId: zod.uuid().regex(ownDutyResponseOutputCurrentItemSourceScheduleIdRegExp),
          routineId: zod.uuid().regex(ownDutyResponseOutputCurrentItemSourceRoutineIdRegExp),
          routineVersionId: zod
            .uuid()
            .regex(ownDutyResponseOutputCurrentItemSourceRoutineVersionIdRegExp),
          positionId: zod.uuid().regex(ownDutyResponseOutputCurrentItemSourcePositionIdRegExp),
          originalUserId: zod
            .uuid()
            .regex(ownDutyResponseOutputCurrentItemSourceOriginalUserIdRegExp),
          originalEligible: zod.boolean(),
          overrideId: zod.union([
            zod.uuid().regex(ownDutyResponseOutputCurrentItemSourceOverrideIdOneRegExp),
            zod.null(),
          ]),
        }),
        start: zod.iso
          .datetime({ offset: true })
          .regex(ownDutyResponseOutputCurrentItemStartRegExp),
        end: zod.iso.datetime({ offset: true }).regex(ownDutyResponseOutputCurrentItemEndRegExp),
      }),
    )
    .max(ownDutyResponseOutputCurrentMax),
  upcoming: zod
    .array(
      zod.object({
        userId: zod.uuid().regex(ownDutyResponseOutputUpcomingItemUserIdRegExp),
        source: zod.object({
          scheduleId: zod.uuid().regex(ownDutyResponseOutputUpcomingItemSourceScheduleIdRegExp),
          routineId: zod.uuid().regex(ownDutyResponseOutputUpcomingItemSourceRoutineIdRegExp),
          routineVersionId: zod
            .uuid()
            .regex(ownDutyResponseOutputUpcomingItemSourceRoutineVersionIdRegExp),
          positionId: zod.uuid().regex(ownDutyResponseOutputUpcomingItemSourcePositionIdRegExp),
          originalUserId: zod
            .uuid()
            .regex(ownDutyResponseOutputUpcomingItemSourceOriginalUserIdRegExp),
          originalEligible: zod.boolean(),
          overrideId: zod.union([
            zod.uuid().regex(ownDutyResponseOutputUpcomingItemSourceOverrideIdOneRegExp),
            zod.null(),
          ]),
        }),
        start: zod.iso
          .datetime({ offset: true })
          .regex(ownDutyResponseOutputUpcomingItemStartRegExp),
        end: zod.iso.datetime({ offset: true }).regex(ownDutyResponseOutputUpcomingItemEndRegExp),
      }),
    )
    .max(ownDutyResponseOutputUpcomingMax),
});

export type OwnDutyResponseOutput = zod.input<typeof OwnDutyResponseOutput>;
export type OwnDutyResponseOutputOutput = zod.output<typeof OwnDutyResponseOutput>;
